import { FormGroup, Validators } from '@angular/forms';

import { ReceiptValidationAction } from './receipt-validation-action.enum';
import { FieldValidatorsMap, FormValidatorsMap } from '../interfaces';

import { ObjectLike } from 'app/interfaces';
import { FormModel } from 'app/models';
import { isIban } from 'app/validators';

export class ReceiptRules extends FormModel<ReceiptValidationAction> {
    baseValidators: FieldValidatorsMap = {
        accountHolderName: [Validators.required],
        accountNumber: [Validators.required],
        amount: [Validators.required, Validators.min(0.01)],
        description: [],
        serviceName: [Validators.required],
        serviceProviderName: [Validators.required],
    };
    formValidators: FormValidatorsMap = {
        [ReceiptValidationAction.Store]: {
            accountNumber: [isIban()],
        },
    };

    getStoreForm(formFrom: ObjectLike = {}): FormGroup {
        return this.createFormGroup(ReceiptValidationAction.Store, formFrom);
    }
}
